<!--page starts-->
 <section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
           <div class="news-hero-detail">
           	   <div class="news-arrow">
                   <a href="javascript:void(0)"><img src="assets/images/down-arrow.svg"></a>  
               </div>
           </div>
        </div>
    </div>
    <div class="news-bottom-section cf">
       <div class="container">
           <div class="news-bottom-detail cf">
                <div class="titel-box">
	      	 		<h2 class="titel-name">News</h2>
	      	 	</div>
	      	 	<div class="news-tab-detail cf">
                    <div class="news-tab">
                        <ul class="category">
							<li class="courses-name active"  id="tab-all" ><a href="#" >All</a></li> 
							<li class="courses-name "  id="tab-{{category?.news_catagory_id}}" *ngFor="let category of newscategoryList?.data; let i = index"><a href="#" id="{{category?.news_catagory_id}}">{{category?.title}}</a></li> 
                          
                        </ul>
                    </div>
					<div class="news-tab-content course-main-content cf active"  id="tab-all-content">
						<!-- <div class="news-tab-content-loader">
							<div class="news-tab-content-loader-inner">
								<a href="#"><img src="assets/images/CriminalWhichEasteuropeanshepherd-size_restricted.gif"></a>
							</div>
						</div> -->
						<div class="news-tab-content-detail">
							<div *ngIf="newsallList?.length > 0">
								<div class="latest-new-box academy" *ngFor="let news of newsallList; let i = index">
									<a [routerLink]="['/news', news?.slug]">
										<div class="latest-new-image">
											<img [src]="news?.thumbnail_image">
										</div>
										<div class="latest-new-content">
											<h4>{{news?.date | amDateFormat: "DD MMMM YYYY"}}</h4>
											<p>{{news?.title}}</p>
										</div>
									</a>
								</div>
							</div>
							<div class="news-tab-btn" *ngIf="!newsList_alllast_page">
								<a (click)="getMoreallNews()">View More</a>
							</div>
						</div>
		      	 		
                    </div>
                    <div class="news-tab-content course-main-content cf"  id="tab-{{category?.news_catagory_id}}-content" *ngFor="let category of newscategoryList?.data; let i = index">
                        <div class="news-tab-content-loader" *ngIf="loading_page">
							<div class="news-tab-content-loader-inner">
								<a href="#"><img src="assets/images/CriminalWhichEasteuropeanshepherd-size_restricted.gif"></a>
							</div>
						</div>
						<div class="news-tab-content-detail" *ngIf="!loading_page">
							<div *ngIf="newsList?.length > 0">
								<div class="latest-new-box academy" *ngFor="let news of newsList; let i = index">
									<a [routerLink]="['/news', news?.slug]">
										<div class="latest-new-image">
											<img [src]="news?.thumbnail_image">
										</div>
										<div class="latest-new-content">
											<h4>{{news?.date | amDateFormat: "DD MMMM YYYY"}}</h4>
											<p>{{news?.title}}</p>
										</div>
									</a>
								</div>
							</div>
							<div class="news-tab-btn">
								<a (click)="getMoreNews()">View More</a>
							</div>
						</div>
		      	 		
                    </div>
					<!-- <div >loader</div> -->
					
                    <!-- <div class="news-tab-content course-main-content  cf" id="women-girls-content">
                        <div class="latest-new-box women-girls">
		      	 			<a href="#">
		      	 				<div class="latest-new-image">
		      	 					<img src="assets/images/letest-new-image.jpg">
		      	 				</div>
			      	 			<div class="latest-new-content">
			      	 				<h4>23rd December 2020</h4>
			      	 				<p>Leicestershire Monthly Report - December 2020</p>
			      	 			</div>
			      	 		</a>
		      	 		</div>
		      	 		<div class="latest-new-box women-girls">
		      	 			<a href="#">
		      	 				<div class="latest-new-image">
		      	 					<img src="assets/images/letest-new-image.jpg">
		      	 				</div>
			      	 			<div class="latest-new-content">
			      	 				<h4>23rd December 2020</h4>
			      	 				<p>Leicestershire Monthly Report - December 2020</p>
			      	 			</div>
			      	 		</a>
		      	 		</div>
		      	 		<div class="latest-new-box women-girls">
		      	 			<a href="#">
		      	 				<div class="latest-new-image">
		      	 					<img src="assets/images/letest-new-image.jpg">
		      	 				</div>
			      	 			<div class="latest-new-content">
			      	 				<h4>23rd December 2020</h4>
			      	 				<p>Leicestershire Monthly Report - December 2020</p>
			      	 			</div>
			      	 		</a>
		      	 		</div>
		      	 		<div class="latest-new-box women-girls">
		      	 			<a href="#">
		      	 				<div class="latest-new-image">
		      	 					<img src="assets/images/letest-new-image.jpg">
		      	 				</div>
			      	 			<div class="latest-new-content">
			      	 				<h4>23rd December 2020</h4>
			      	 				<p>Leicestershire Monthly Report - December 2020</p>
			      	 			</div>
			      	 		</a>
		      	 		</div>
		      	 		<div class="latest-new-box women-girls">
		      	 			<a href="#">
		      	 				<div class="latest-new-image">
		      	 					<img src="assets/images/letest-new-image.jpg">
		      	 				</div>
			      	 			<div class="latest-new-content">
			      	 				<h4>23rd December 2020</h4>
			      	 				<p>Leicestershire Monthly Report - December 2020</p>
			      	 			</div>
			      	 		</a>
		      	 		</div>
		      	 		<div class="latest-new-box women-girls">
		      	 			<a href="#">
		      	 				<div class="latest-new-image">
		      	 					<img src="assets/images/letest-new-image.jpg">
		      	 				</div>
			      	 			<div class="latest-new-content">
			      	 				<h4>23rd December 2020</h4>
			      	 				<p>Leicestershire Monthly Report - December 2020</p>
			      	 			</div>
			      	 		</a>
		      	 		</div>
		      	 		<div class="news-tab-btn">
                            <a href="javascript:void(0);" id="loadMore-one">View More</a>
		      	 		</div>
                    </div> -->
	      	 	</div>
           </div> 
       </div>
    </div>
</section><!-- page ends-->